export const campaignConfig = {
    campaignListConfig: 'campaign_devapp', // campaign_devapp
    campaignHotPromotion: 'campaign_jcb_hotpromotion',
    campaignPlatinumListConfig: 'campaign_jcb_platinumservice',
    campaignSpecialForYou: 'campaign_jcb_specialforyou',
    campaignUltimateService: 'campaign_jcb_ultimateservice'
};

export const dashboardConfig = {
    mainDashboard: '',
    platinumService: 'jcb_platinum_service',
    dashboardHotPromotion: 'jcb_hot_promotion',
    searchPromotion: 'jcb_searching_promotion',
    searchPromotionSubCategory: 'jcb_searching_promotion_sub_category',
    applyCard: 'jcb_apply_card',
    registered: 'jcb_registered_campaign',
    jcbCardPrivilege: 'jcb_card_privilege',
    jcbUltimaterService: 'jcb_ultimate_service',
    jcbSpecialForYou: 'jcb_special_for_you'
};

export const categoryConfig = {
    menuCategory: 'menu_devapp',
    hotPromotion: 'menu_jcb__hot_promotion',
    special4you: 'menu_jcb_specialforyou',
    platinumService: 'menu_jcb_platinumservice',
    ultimateService: 'menu_jcb_ultimateservice'
};

export const historyConfig = {
    purchase: 'purchase',
    purchaseUsed: 'purchase_used',
    purchaseUnused: 'purchase_unused'
};

export default { campaignConfig, dashboardConfig, categoryConfig, historyConfig }
